"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductImplementation = void 0;
const common_1 = require("../../common");
const models_1 = require("../../hr/models");
const models_2 = require("../../production/models");
const models_3 = require("../../products/models");
const enums_1 = require("../enums");
const product_implementation_commitment_model_1 = require("./product-implementation-commitment.model");
const product_implementation_document_model_1 = require("./product-implementation-document.model");
class ProductImplementation extends common_1.MongoDocument {
}
exports.ProductImplementation = ProductImplementation;
//# sourceMappingURL=product-implementation.model.js.map